/**
 * Equal-prominence alternatives to the brief form. The constitution
 * explicitly forbids "form-gating" the contact path — visitors who don't
 * want to fill a form get email + LinkedIn surfaced at the same weight as
 * the form's submit button.
 */
export function ContactAlternatives() {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Card
        href="mailto:joao@jgson.net"
        title="Email"
        detail="joao@jgson.net"
        external={false}
      />
      <Card
        href="https://www.linkedin.com/in/jgvidotto/"
        title="LinkedIn"
        detail="/in/jgvidotto"
        external
      />
      <PlaceholderCard
        title="Book a call"
        detail="Cal.com link coming soon"
      />
    </div>
  );
}

interface CardProps {
  href: string;
  title: string;
  detail: string;
  external: boolean;
}

function Card({ href, title, detail, external }: CardProps) {
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      className="group flex flex-col gap-1 rounded-xl border border-jg-border bg-jg-bg-soft/40 p-4 transition-colors hover:bg-jg-bg-soft"
    >
      <span className="font-display text-sm font-semibold text-jg-fg">
        {title}
      </span>
      <span className="text-xs text-jg-fg-muted group-hover:text-jg-fg">
        {detail}
      </span>
    </a>
  );
}

interface PlaceholderProps {
  title: string;
  detail: string;
}

function PlaceholderCard({ title, detail }: PlaceholderProps) {
  return (
    <div className="flex flex-col gap-1 rounded-xl border border-dashed border-jg-border bg-jg-bg-soft/20 p-4">
      <span className="font-display text-sm font-semibold text-jg-fg-muted">
        {title}
      </span>
      <span className="text-xs text-jg-fg-muted">{detail}</span>
    </div>
  );
}
